import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingDotsProps {
  /** Custom className for the container */
  className?: string;
  /** Size of each dot in pixels */
  dotSize?: number;
}

/**
 * Animated loading dots component
 * Shows three dots with staggered pulse animation
 *
 * @example
 * <LoadingDots />
 * <LoadingDots dotSize={3} className="my-custom-class" />
 */
export const LoadingDots: React.FC<LoadingDotsProps> = ({
  className,
  dotSize = 2,
}) => {
  return (
    <div className={cn('flex items-center gap-1', className)}>
      {[0, 1, 2].map((index) => (
        <span
          key={index}
          className={cn(
            'rounded-full bg-muted-foreground opacity-70',
            'animate-pulse',
          )}
          style={{
            width: `${dotSize * 4}px`,
            height: `${dotSize * 4}px`,
            animationDelay: `${index * 0.2}s`,
            animationDuration: '1.5s',
          }}
        />
      ))}
    </div>
  );
};
